<snelstart-ui-details
        [config]="detailsConfig"
        [entityId]="id"
        title="Servicebericht"
>
    <snelstart-ui-details-content>
        <snelstart-venture-fiscaal-sba [id]="id"></snelstart-venture-fiscaal-sba>
    </snelstart-ui-details-content>

    <snelstart-ui-details-buttons>
        <snelstart-ui-button (click)="toonPdf($event)"
                             icon="file-pdf"
                             type="secondary"
        >PDF
        </snelstart-ui-button>

        @if (!isGecontroleerd()) {
            <snelstart-ui-button type="secondary"
                                 icon="magnifying-glass"
                                 (click)="saveForm($event)">
                <span snelstartUiTooltip="Markeer als 'gecontroleerd'" snelstartUiTooltipPlacement="right">Gecontroleerd?</span>
            </snelstart-ui-button>
        }
        @if (isGecontroleerd()) {
            <snelstart-ui-button type="secondary"
                                 icon="check"
                                 (click)="saveForm($event)">
                Gecontroleerd!
            </snelstart-ui-button>
        }
    </snelstart-ui-details-buttons>

</snelstart-ui-details>
